import React from 'react'

export default function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" {...props}>
      <g fill="var(--svg-color-main, black)" clipPath="url(#a)">
        <path d="M21.239 19.742c.502-1.213.761-2.514.761-3.827H2a10 10 0 0 0 4 8h12a10 10 0 0 0 3.239-4.173"></path>
        <g opacity="0.4">
          <path d="M17.22 2.825c-.913-1.261-2.332-1.908-3.785-1.91A5.41 5.41 0 0 0 9.08 3.142c-.694.96-1.076 2.174-1.076 3.612 0 .824.153 1.72.454 2.679l1.908-.6c-.679-2.16-.313-3.622.335-4.521a3.41 3.41 0 0 1 2.732-1.397c.86.001 1.652.378 2.161 1.082.566.782.425 1.264.246 1.482-.262.319-.677.52-1.08.52-.36 0-.787-.16-1.146-.73l-1.692 1.068c.71 1.124 1.76 1.66 2.835 1.662a3.44 3.44 0 0 0 2.628-1.25A2.64 2.64 0 0 0 18 5.044c0-.629-.291-1.535-.78-2.22M12 19.915c.968 0 1.871-.247 2.637-.676.662.425 1.479.676 2.363.676 2.21 0 4-1.567 4-3.5s-1.79-3.5-4-3.5q-.407 0-.792.069c-.89-1.245-2.442-2.069-4.208-2.069s-3.319.824-4.208 2.069A4.6 4.6 0 0 0 7 12.915c-2.21 0-4 1.567-4 3.5s1.79 3.5 4 3.5c.884 0 1.701-.25 2.363-.676a5.4 5.4 0 0 0 2.637.676"></path>
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 .915h24v24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
}
